"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_PROPS = exports.DEFAULT_EVENT_PROPS = exports.EVENT_ACTIONS = exports.EVENTS_INTERACTIONS = exports.EVENTS_LABELS = exports.EVENTS_CATEGORY = exports.NAMES = exports.GROUPS = exports.SYSTEMS = void 0;
var SYSTEMS;
(function (SYSTEMS) {
    SYSTEMS["APP_CLUB_ADMIN"] = "app_club_admin";
    SYSTEMS["APP_MEMBERSHIP_ADMIN"] = "app_membership_admin";
    SYSTEMS["CONSUMER_ENGAGEMENT"] = "consumer_engagement";
    SYSTEMS["HOTMART_CLUB"] = "hotmart_club";
    SYSTEMS["LEAD_SOLUTIONS"] = "lead_solutions";
})(SYSTEMS || (exports.SYSTEMS = SYSTEMS = {}));
exports.GROUPS = {
    CERTIFICATE_CONFIG: 'certificate_config',
    CONTENT: 'content',
    PLUS_ACCESS: 'plus_access',
    SALES_DASHBOARD: 'sales_dashboard',
    SUBTITLE: 'subtitle',
    USERS_LIST_BULK_ACTIONS: 'users_list_bulk_actions'
};
exports.NAMES = {
    AD_BUTTON: 'click_on_the_ad_button',
    BLOG_LINK: 'click_on_blog_link',
    CARD_MAKE_SALES: 'click_on_the_card_button_make_sales',
    CERTIFICATE: {
        SELECT_QR_CODE_TAG: 'click_to_select_qr_code_tag',
        SAVE_QR_CODE_TAG: 'try_to_save_qr_code_tag'
    },
    DOWNLOAD_SUBTITLE: 'click_on_download_subtitle',
    HELP_CENTER: 'click_on_help_center_button',
    MARKETING_BANNER: 'click_on_the_card_button_start_now_marketing_banner',
    PLUS_ACCESS: {
        CARD_CONFIG_PLUS_ACCESS: 'click_on_card_button_config_plus_access',
        CLICK_TOGGLE: 'click_on_toggle_plus_access',
        MODAL_ACTIVATE_CANCEL: 'click_on_modal_activate_cancel_button',
        MODAL_ACTIVATE_CONDITION: 'click_on_modal_activate_condition',
        MODAL_ACTIVATE_CONFIRM: 'click_on_modal_activate_confirm_button',
        MODAL_DEACTIVATE_CANCEL: 'click_on_modal_deactivate_cancel_button',
        MODAL_DEACTIVATE_CONDITION: 'click_on_modal_deactivate_condition',
        MODAL_DEACTIVATE_CONFIRM: 'click_on_modal_deactivate_confirm_button'
    },
    USERS: 'click_on_users_button',
    USERS_LIST_BULK_ACTIONS: {
        OPEN_BULK_ACTIONS_SELECT: `open_bulk_actions_select`,
        SEND_COMMUNICATIONS: `send_communications`
    },
    CREATE_MODULE: {
        VIEW: 'view_create_module',
        CLICK: 'click_create_module'
    },
    CREATE_AD: {
        VIEW: 'view_create_ad',
        CLICK: 'click_create_ad'
    }
};
exports.EVENTS_CATEGORY = {
    HORIZONTAL_MENU: {
        NOTIFICATIONS_HORIZONTAL_MENU: 'NotificationsHorizontalMenu',
        HORIZONTAL_MENU_ACCOUNT: 'HorizontalMenuAccount'
    },
    EMPTY_STATE_OLD_CLUB_COMMUNITY: 'EmptyStateOldClubCommunity',
    CONTENT: {
        CONTENT_FILES: {
            CONTENT_FILES_LIBRARY: 'ContentFilesLibrary',
            CONTENT_FILES_LIBRARY_LOCAL: 'ContentFilesLibraryLocal',
            CONTENT_FILES_LOCAL: 'ContentFilesLocal',
            NAME: 'ContentFiles'
        },
        CONTENT_LIVE: {
            CONTENT_LIVE_AFTER_STREAM: 'ContentLiveAfterStream',
            CONTENT_LIVE_DESCRIPTION: 'ContentLiveDescription',
            CONTENT_LIVE_SCHEDULER: 'ContentLiveScheduler',
            CONTENT_LIVE_THUMBNAIL: 'ContentLiveThumbnail',
            CONTENT_LIVE_TITLE: 'ContentLiveTitle',
            CONTENT_LIVE_TRANSMISSION_METHOD: 'ContentLiveTransmissionMethod',
            LIVE_ANNOUNCEMENT_MODAL: 'LiveAnnouncementModal',
            LIVE_ONBOARDING_CARD: 'LiveOnBoardingCard',
            NAME: 'ContentLive'
        },
        CONTENT_MODULE_EDITOR: 'ContentModuleEditor',
        CONTENT_ONBOARDING: 'ContentOnboarding',
        CONTENT_PAGE: {
            CONTENT_MANAGE_PAGE: 'ContentManagePage',
            NAME: 'ContentPage'
        },
        CONTENT_SCHEDULE: {
            CONTENT_SCHEDULE_DETAIL_TOOLTIP: 'ContentScheduleDetailTooltip',
            CONTENT_SCHEDULE_DRIPPING_BY_DAY: 'ContentScheduleDrippingByDay',
            CONTENT_SCHEDULE_EXPIRATION: 'ContentScheduleExpiration',
            NAME: 'ContentSchedule'
        },
        CONTENT_TABS: 'ContentTabs',
        MANAGE_MODULE: {
            CREATE_CONTENT: 'CreateContent',
            MANAGE_MODULE_ICON: 'ManageModuleIcon',
            NAME: 'ManageModule'
        },
        NAME: 'Content'
    },
    DRM_SETTINGS: {
        ACTIVATE: 'DrmSettingsActivate',
        CONFIRM_ACTIVATE: 'DrmSettingsConfirmActivate',
        CONFIRM_DEACTIVATE: 'DrmSettingsConfirmDeactivate',
        DEACTIVATE: 'DrmSettingsDeactivate'
    },
    DUPLICATION_CONTENT: {
        CLOSE_MODAL: 'DuplicationContentCloseModal',
        CONTENT: 'DuplicationContentContent',
        MODULE: 'DuplicationContentModule',
        DUPLICATE_MODULE: 'DuplicationContentDuplicateModule'
    },
    MEMBERSHIP_BANNER: 'MembershipBanner',
    SALES_SECTION: 'SalesSection',
    SETTINGS: 'Settings',
    SPARKLE_CAMPAIGN: {
        NAME: 'SparkleCampaign',
        SPARKLE_CAMPAIGN_MODAL_PRODUCER: 'SparkleCampaignModalProducer'
    },
    STREAMING_CAMPAIGN: {
        NAME: 'StreamingCampaign',
        STREAMING_CAMPAIGN_MODAL: 'StreamingCampaignModal'
    },
    VERTICAL_MENU: {
        NAME: 'VerticalMenu',
        VERTICAL_MENU_VIEW_AS: 'VerticalMenuViewAs'
    },
    CLASS: {
        NEW_CLASS: 'NewClass',
        VIEW_MORE_ITEMS: 'ViewMoreItems',
        EDIT_CLASS: 'EditClass',
        EDIT_LIST_CLASS: 'EditListClass',
        DELETE_CLASS: 'DeleteClass',
        CLASS_SEARCH: 'ClassSearch',
        CANCEL_DELETE_CLASS: 'CancelDeleteClass',
        CONFIRM_DELETE_CLASS: 'ConfirmDeleteClass',
        CREATE_CLASS: 'CreateClass',
        UPDATE_CLASS: 'UpdateClass'
    },
    CERTIFICATE: {
        ENABLE_CERTIFICATE: 'EnableCertificate'
    },
    LEARNING_TRACK: 'LearningTrack',
    LEGACY_REDIRECT_ALERT: 'LegacyRedirectAlert',
    CLICK_SURVEY_THIRDY_PRODUCTS: 'clickSurveyThirdyProducts'
};
exports.EVENTS_LABELS = {
    ACCEPTED: 'accepted',
    BACK: 'Back',
    PAGE_VIEW: 'PageView',
    BUTTON_KNOW_MORE: 'ButtonKnowMore',
    BUTTON_ACCESS_COMMUNITY: 'ButtonAccessCommunity',
    CONTENT: {
        ADD_MODULE: 'AddModule',
        CONTENT_FILES: {
            PAGE_LIBRARY_LOCAL_UPLOAD: 'PageLibraryLocalUpload',
            PAGE_LIBRARY_SELECT: 'PageLibrarySelect',
            PAGE_LOCAL_UPLOAD: 'PageLocalUpload'
        },
        CONTENT_LIVE: {
            DESCRIPTION: 'Description',
            TITLE: 'Title',
            UPLOAD: 'Upload'
        },
        CONTENT_MODULE_EDITOR: {
            NEW_MODULE_FREE: 'NewModuleFree'
        },
        CONTENT_ONBOARDING: {
            BACK_TO_REGISTER: 'BackToRegister',
            MEMBERS_AREA_READY: 'MembersAreaReady'
        },
        CONTENT_PAGE: {
            ACCESS_PANEL: 'AccessPanel',
            CHECK_PAGE: 'CheckPage',
            EDIT_PAGE: 'EditPage',
            EDIT_TITLE: 'EditTitle',
            ORDER_PAGE: 'OrderPage',
            REMOVE_PAGE: 'RemovePage',
            VIEW_PAGE: 'ViewPage'
        },
        CONTENT_SCHEDULE: {
            BY_DATE: 'ByDate',
            BY_DATE_CANCEL: 'ByDateCancel',
            BY_DATE_SAVE: 'ByDateSave',
            CANCEL_REMOVE_DRIPPING: 'CancelRemoveDripping',
            CUSTOM_DAYS_SAVE: 'CustomDaysSave{{days}}Days',
            DAYS: {
                CUSTOM: 'Custom',
                FIFTEEN_DAYS: '15Days',
                SEVEN_DAYS: '7Days',
                THIRTY_DAYS: '30Days',
                UNDEFINED: 'Undefined'
            },
            DRIPPING_BY_DATE: 'DrippingByDate',
            DRIPPING_BY_DAYS: 'DrippingByDay',
            EXPIRATION: 'Expiration',
            SAVE_REMOVE_DRIPPING: 'SaveRemoveDripping',
            SELECT_MONTH: 'SelectMonth',
            SELECT_YEAR: 'SelectYear',
            SCHEDULE: 'Schedule'
        },
        EXTRA_TAB: 'ExtraTab',
        EXPAND_MODULES: 'ExpandModules',
        MAIN_TAB: 'MainTab',
        MANAGE_MODULE: {
            ADS: 'Ads',
            CHECK_ALL_PAGES: 'CheckAllPages',
            CREATE_CONTENT_PAGE: 'CreateContentPage',
            EDIT: 'Edit',
            EDIT_TITLE: 'EditTitle',
            EXPAND_PAGES: 'ExpandPages',
            LIVE: 'Live',
            ORDER_MODULE: 'OrderModule',
            QUIZ: 'Quiz',
            RETRACT_PAGES: 'RetractPages',
            VIEW_GROUPS: 'ViewGroups'
        },
        PUBLISH: 'Publish',
        PUBLISH_AND_NOTIFY: 'PublishAndSendEmail',
        REMOVE: 'Remove',
        UNDO_PUBLISH: 'UndoPublish',
        UPLOAD_FILES: 'UploadFiles',
        UPLOAD_MODULE_COVER_IMAGE: 'UploadModuleCoverImage'
    },
    COUNTRY: 'Country',
    DATE: 'Date',
    DRM_SETTINGS: {
        ACTIVATE: 'Activate',
        CONFIRM_ACTIVATE: 'ConfirmActivate',
        CONFIRM_DEACTIVATE: 'ConfirmDeactivate',
        DEACTIVATE: 'Deactivate'
    },
    DUPLICATION_CONTENT: {
        DUPLICATE_MODULE: 'Duplicate Module'
    },
    EXIT: 'Exit',
    HORIZONTAL_MENU: {
        ACCOUNT: 'Account',
        NOTIFICATION_ICON: 'NotificationIcon',
        SHOW_ALL: 'ShowAll',
        VIEW_MESSAGE: 'ViewMessage'
    },
    HOUR: 'Hour',
    MEMBERSHIP_BANNER: {
        LEARN_MORE: 'LearnMore'
    },
    MINUTE: 'Minute',
    MY_ACCOUNT: 'MyAccount',
    NEXT: 'Next',
    REFUSED: 'refused',
    SALES_SECTION: {
        FREE_SIGN_UP: 'FreeSignUp'
    },
    SPARKLE_CAMPAIGN: {
        ACTIVATE_HOTMART_COMMUNICATION: 'ActivateHotmartCommunication',
        MODAL_VIDEO_PLAYER: 'modalVideoPlay'
    },
    STREAMING_CAMPAIGN: {
        ACTIVATE_HOTMART_VIDEO_PLAYER: 'ActivateHotmartVideoPlayer'
    },
    TIMEZONE: 'TimeZone',
    VERTICAL_MENU: {
        COMMENTS: 'Comments',
        COMMUNITIES: 'Communities',
        CONTENT: 'Content',
        GROUPS: 'GROUPS',
        HOME: 'Home',
        MESSAGE: 'MESSAGE',
        REPORTS: 'Reports',
        SALES: 'Sales',
        SETTINGS: 'Settings',
        USERS: 'Users'
    },
    CLASS: {
        CLASS_ID: 'ClassId',
        SEARCH_RESULTS: 'Results',
        NO_SEARCH_RESULTS: 'NoResults'
    },
    AB_TEST: {
        EXTERNAL_AD_BUTTON_CREATE_CLUB_SALES: 'ExternalAdButtonCreateClubSales',
        DROPDOWN_AD_BUTTON_CREATE_CLUB_SALES: 'DropdownAdButtonCreateClubSales',
        EXTERNAL_AD_BUTTON_SAVE_CLUB_SALES: 'ExternalAdButtonSaveClubSales',
        DROPDOWN_AD_BUTTON_SAVE_CLUB_SALES: 'DropdownAdButtonSaveClubSales'
    },
    LEARNING_TRACK: {
        OLD_CLUB_EMPTY_STATE_KNOW_MORE_BUTTON: 'OldClubEmptyStateKnowMoreButton',
        OLD_CLUB_EMPTY_STATE_ACCESS_HOTMART_CLUB_BUTTON: 'OldClubEmptyStateAccessHotmartClubButton'
    },
    LEGACY_REDIRECT_ALERT: {
        KNOW_MORE_BUTTON_CLICK: 'KnowMoreRedirectAlert',
        CLOSE_BUTTON_CLICK: 'CloseRedirectAlert',
        FREQUENTLY_ASKED_QUESTIONS_CLICK: 'FrequentlyAskedQuestionsRedirectAlert',
        CLOSE_MORE_INFO_BUTTON_CLICK: 'CloseMoreInfoRedirectAlert',
        KNOW_MORE_INFO_BUTTON_CLICK: 'KnowMoreInfoRedirectAlert'
    }
};
exports.EVENTS_INTERACTIONS = {
    CLICK: 'Click',
    HOVER: 'Hover',
    MODAL_ACTIVATE: 'ModalActivate',
    PLAY_VIDEO_MODAL: 'playVideoModal',
    SHOW: 'Show',
    TOGGLE_OFF: 'ToggleOff',
    TOGGLE_ON: 'ToggleOn'
};
exports.EVENT_ACTIONS = {
    INTERACT: 'interact',
    NAVIGATE: 'navigate'
};
exports.DEFAULT_EVENT_PROPS = {
    data_version: '1.0'
};
exports.EVENT_PROPS = {
    [exports.EVENT_ACTIONS.NAVIGATE]: {
        ...exports.DEFAULT_EVENT_PROPS,
        entity: 'user',
        action: 'navigate'
    },
    [exports.EVENT_ACTIONS.INTERACT]: {
        ...exports.DEFAULT_EVENT_PROPS,
        entity: 'user',
        action: exports.EVENT_ACTIONS.INTERACT
    }
};
